import { FlagIcon, Flex, Select, Typography } from "@aircall/tractor";
import {
  LanguageOption,
  SCORE_CARD_LANGUAGES,
  ScorecardLanguageSelectProps,
} from ".";

export function ScorecardLanguageSelect({
  onChange,
  value,
}: ScorecardLanguageSelectProps) {
  const renderOption = ({ languageCode, name }: LanguageOption) => (
    <Flex gap="xxs" alignItems="center">
      <FlagIcon countryCode={languageCode} />
      <Typography variant="bodyRegularS">{name}</Typography>
    </Flex>
  );
  return (
    <Select<string, LanguageOption>
      selectedKeys={[value]}
      options={SCORE_CARD_LANGUAGES}
      onSelectionChange={(keys) => {
        onChange(keys[0]);
      }}
      renderOption={renderOption}
      getOptionValue={(option) => option.languageCode}
      getOptionLabel={(option) => option.name}
    />
  );
}
